var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.selectedReport === 'all-order')?_c('div',[_c('report-downloads-table',{key:_vm.selectedReport})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }